import {
    call, put, takeEvery, all,
} from 'redux-saga/effects';
import { GET_USER_PROFILE_REQUEST } from '../../constants/get_user_profile.constants';
import { getUserProfile } from '../../../requests/user_profile_requests/get_user_profile_request';
import {
    inviteUserDepartment, inviteUserGender, inviteUserNamePrefixes, inviteUserRoles, inviteLeadSources,
} from '../../../requests/user_profile_requests/invite_user_data_request';
import { getUserProfileRequestSuccess, getUserProfileRequestFailure } from '../../actions/user_profile_actions/get_user_profile.actions';
import { inviteUserDataFailure } from '../../actions/invite_user_data.actions';
import { message_error } from '../../../../../../components/Message';

function* getUserProfileRequest({ id }) {
    const { result, error, options } = yield call(getUserProfile, id);

    if (result) {
        const [departments, gender, prefixes, roles, divisions, error] = yield all([
            call(inviteUserDepartment),
            call(inviteUserGender),
            call(inviteUserNamePrefixes),
            call(inviteUserRoles),
            call(inviteLeadSources),
        ]);

        departments && gender && prefixes
            ? yield put(getUserProfileRequestSuccess(options, {
                departments, gender, prefixes, roles, divisions,
            }))
            : yield put(inviteUserDataFailure(error));
    } else {
        yield put(getUserProfileRequestFailure(error));
        message_error(error);
    }
}

export default function* getUserProfileSaga() {
    yield takeEvery(GET_USER_PROFILE_REQUEST, getUserProfileRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_profile_sagas/get_user_profile.saga.js